import React from 'react';
import { FormControl, FormControlLabel, Typography } from '@mui/material';
import { useRecoilState, useRecoilValue } from 'recoil';
import { OrderPayload, urlParams } from 'pages/reference-implementation/provisioning/RI003AWS/store';
import riStyle, { CustomRadioGroup, CustomRadio } from 'pages/reference-implementation/Style';

const IsExternalRadio = () => {
    const [order, setOrder] = useRecoilState(OrderPayload);
    const params = useRecoilValue(urlParams);

    const handleOnSelectChange = (isExternal) => {
        if (params?.journeyId === null)
            setOrder({
                ...order,
                isExternal,
                appUrl: '',
                appSupportMailId: '',
                adCertGroup: null,
            });
        else
            setOrder({
                ...order,
                isExternal,
                dataClassification: null,
            });
    };
    return (
        <>
            <Typography sx={riStyle?.form?.accessMgmt?.label}>
                Please specify whether the application to be externalized(web application) or Internal(microservice) <span style={{ color: 'red' }}>*</span>
            </Typography>
            <FormControl data-testid="is-external-radio-box">
                <CustomRadioGroup
                    aria-label="IsExternalRadio"
                    name="isExternalRadioBtnGroup"
                    row
                    value={order?.isExternal || null}
                    onChange={(event, value) => handleOnSelectChange(value)}
                >
                    <FormControlLabel value="Yes" control={<CustomRadio />} label="Web Application" />
                    <FormControlLabel
                        value="No"
                        sx={{
                            marginLeft: '60px',
                        }}
                        control={<CustomRadio />}
                        label="Microservice"
                    />
                </CustomRadioGroup>
            </FormControl>
        </>
    );
};

export default IsExternalRadio;
